import { useRegisterEvents, useSigma } from '@react-sigma/core';
import DocumentCard from '../../components/DocumentCard';
import { useEffect, useMemo, useState } from 'react';
import { Sigma } from 'sigma';

export default function FloatingDocument(props: {
  elementId: string;
  id: string;
  onClose: () => void;
}) {
  const [nodeInitialized, setNodeInitialized] = useState(false);
  let sigma = useSigma();
  const registerEvents = useRegisterEvents();
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    let calculatedPosition = calcPosition(props.elementId, sigma);
    if (calculatedPosition.x == 0 && calculatedPosition.y == 0) {
      setNodeInitialized(false);
    } else {
      setPosition(calculatedPosition);
      setNodeInitialized(true);
    }
  }, [sigma.getGraph()]);

  const ViewportPositionListener = useMemo(
    () => () => {
      let calculatedPosition = calcPosition(props.elementId, sigma);
      if (calculatedPosition.x == 0 && calculatedPosition.y == 0) {
        setNodeInitialized(false);
      } else {
        setPosition(calculatedPosition);
        setNodeInitialized(true);
      }
    },
    [props.elementId, sigma],
  );

  useEffect(() => {
    registerEvents({ updated: ViewportPositionListener });
  }, [props.elementId, registerEvents, sigma]);

  if (!nodeInitialized) {
    return null;
  } else {
    return (
      <DocumentCard
        style={{ position: 'absolute', top: position.y, left: position.x }}
        id={props.id}
        onClose={props.onClose}
      />
    );
  }
}

function calcPosition(elementId: string, sigma: Sigma) {
  if (!elementId || elementId == '' || !sigma) {
    console.error('No elementId or sigma provided');
    return { x: 0, y: 0 };
  }
  try {
    let attributes = sigma.getGraph().getNodeAttributes(elementId);
    let viewportPosition = sigma.graphToViewport({ x: attributes.x, y: attributes.y });
    viewportPosition.x = viewportPosition.x - 200;
    viewportPosition.y = viewportPosition.y + 10;
    return viewportPosition;
  } catch (e) {
    console.error(e);
    return { x: 0, y: 0 };
  }
}
